

export function present<T>(value: T): value is Exclude<T, false | undefined | null | ''> {
  if (typeof value == 'string') {
    return value && /\S/.test(value)
  }

  return !!value
}
